import React from 'react'

const VideoGenerator = () => {
  return (
    <div>VideoGenerator</div>
  )
}

export default VideoGenerator